import { apiConfig, request } from '../../../../io';
// 获取消息列表
export async function getMeassageList(data) {
    return request(`${apiConfig.apiMessage}/v1/mc/msg/records/table`, {
        method: 'POST',
        data,
    });
}
// 通过id查询-消息记录(查询设置已读)
export async function getMessageInfo(id) {
    return request(`${apiConfig.apiMessage}/v1/mc/msg/records/${id}`, {
        method: 'GET',
    });
}
// 获取消息未读数
export async function getUnreadMeassageCountInfo() {
    return request(`${apiConfig.apiMessage}/v1/mc/msg/records/total/info`, {
        method: 'GET',
    });
}
// 设置已读
export async function setAllDoneRead(data) {
    return request(`${apiConfig.apiMessage}/v1/mc/msg/records/read/all/${data}`, {
        method: 'PUT',
    });
}
// 更换管理员详情
export const getAdminApplyApi = (busId) => {
    return request(`${apiConfig.apiUims}/v1/sys/company/admin/apply/${busId}`, {
        method: 'get',
    });
};
// 获取站内信详情
export const getBoxInfoApi = (id, headers) => {
    return request(`${apiConfig.apiUims}/v1/finance/certification/inbox/${id}`, {
        method: 'get',
        headers,
    });
};
export function downloadMinioFileApi(bucket, objectName, fileName) {
    return () => new Promise(async (resolve, reject) => {
        try {
            const r = await request(`${apiConfig.apiMinio}/v1/file/download/file`, {
                method: 'get',
                responseType: 'blob',
                params: {
                    bucket,
                    objectName,
                    fileName,
                },
            });
            resolve(new Blob([r]));
        }
        catch (error) {
            reject(error);
        }
    });
}
// 修改更换管理员
export const putAdminApplyApi = (data) => {
    return request(`${apiConfig.apiUims}/v1/sys/company/admin/apply`, {
        method: 'put',
        data,
    });
};
// 修改财务管理员人工审核
export const putFinanceDetailApi = (id) => {
    return request(`${apiConfig.apiUims}/v1/finance/certification/${id}`, {
        method: 'put',
    });
};
